export const AUTH_PROMPT_STRINGS = {
  TITLE: "Sign in to continue",
  MESSAGE: "Create an account or sign in to use this feature.",
  SIGN_IN: "Sign in",
  SIGN_UP: "Sign up",
  DISMISS: "Not now",
} as const;
